import { alpha, inputBaseClasses, outlinedInputClasses, Theme } from '@mui/material';

import scssVariables from 'styles/sass-variables.module.scss';

export const inputLabelOverride = {
  root: ({ theme }: { theme: Theme }) => ({
    fontSize: 12,
    fontWeight: 700,
    marginBottom: theme.spacing(0.5),
    color: scssVariables.greys_black,
    whiteSpace: 'break-spaces',
  }),
};

export const baseInputOverride = {
  root: ({ theme }: { theme: Theme }) => ({
    [`&.${outlinedInputClasses.error}`]: {
      input: {
        borderColor: `${alpha(theme.palette.error.main, 0.5)}!important`,
      },
    },
  }),
  input: () => ({
    fontSize: 14,

    ['&' + '::placeholder']: {
      fontSize: 14,
      opacity: 'unset',
      color: scssVariables.text_grey,
    },

    [`&.${inputBaseClasses.disabled}`]: {
      WebkitTextFillColor: scssVariables.greys_disabled_text,
      color: scssVariables.greys_disabled_text,
      cursor: 'not-allowed',
    },
  }),
};

export const outlinedInputOverride = {
  root: ({ theme }: { theme: Theme }) => ({
    padding: 0,
    paddingRight: theme.spacing(1),
    borderRadius: 8,
    backgroundColor: theme.palette.common.white,

    ['& fieldset']: {
      borderWidth: 1,
      borderColor: scssVariables.greys_border,
    },

    [`& .${outlinedInputClasses.notchedOutline}`]: {
      borderWidth: 1,
    },
    [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: scssVariables.primary_purple_400,
    },
    [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
      borderWidth: 1,
      borderColor: scssVariables.primary_purple_400,
    },
    [`&.${outlinedInputClasses.error} .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: alpha(theme.palette.error.main, 0.4),
    },

    [`&.${outlinedInputClasses.disabled}`]: {
      borderColor: scssVariables.greys_border,
      cursor: 'not-allowed',

      ['& fieldset']: {
        borderColor: `${scssVariables.greys_border}!important`,
      },
    },
  }),

  input: ({ theme }: { theme: Theme }) => ({
    padding: theme.spacing(1.25, 2),
  }),

  multiline: {
    padding: 0,
  },
};
